import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { NotificationManager } from "react-notifications";
import * as API from "../api/index";
import { useDataView } from "../../contexts/data.view.context";
import { FormField, FormSelectField, FormActions } from "../util/formFields";

const ViewEditAPIConfig = ({
  curRow,
  handleDetailClose,
  editable,
  onEditClick,
  data,
}) => {
  const { fetchAPIConfigsFromAllEnv } = useDataView();
  const values = curRow.original;

  const [formData, setFormData] = useState({
    _API_ID: values._API_ID,
    API_ID: values.API_ID,
    MOD: values.MOD,
    PATH: values.PATH,
    OPERATION: values.OPERATION,
    STATE: values.STATE,
    NAME: values.NAME,
    REF_TYPE: values.REF_TYPE,
    REF_ID: values.REF_ID,
    SECURITY_POLICY: values.SECURITY_POLICY,
    SAMPLE_DATA: values.SAMPLE_DATA,
    REF_DATA: values.REF_DATA,
  });

  const operations = ["GET", "POST", "PUT", "DELETE", "PATCH"];
  const states = ["Active", "Disabled"];
  const refTypes = [
    "AWARDCO",
    "CTPO",
    "DataQuery",
    "ESB",
    "FileQuery",
    "INCYTE",
  ];

  function handleSubmit(event) {
    event.preventDefault();
    const edited_api_id = formData.API_ID;
    const org_api_id = values.API_ID;
    let checkAPIid = null;

    if (org_api_id === edited_api_id) {
      // api id is not edited
    } else {
      checkAPIid = data.find((apiConfig) => apiConfig.API_ID === edited_api_id);
    }

    if (checkAPIid) {
      NotificationManager.error("", "API ID exists!", 10000);
    } else {
      const payload = [
        {
          _API_ID: values._API_ID,
          API_ID: formData.API_ID,
          MOD: formData.MOD,
          PATH: formData.PATH,
          OPERATION: formData.OPERATION,
          STATE: formData.STATE,
          NAME: formData.NAME,
          REF_TYPE: formData.REF_TYPE,
          REF_ID: formData.REF_ID,
          SECURITY_POLICY: formData.SECURITY_POLICY,
          SAMPLE_DATA: formData.SAMPLE_DATA,
          REF_DATA: formData.REF_DATA,
        },
      ];

      const resourcePath = "integrations/cfg/apiconfigs";

      API.UpdateRecord(resourcePath, payload).then((response) => {
        if (response.code === 200) {
          fetchAPIConfigsFromAllEnv();
          NotificationManager.success("Record Updated", "API Config", 10000);
        } else {
          NotificationManager.error(response.message, "Failed!", 10000);
        }
      });
    }
  }

  function handleClone(event) {
    event.preventDefault();
    const API_ID = formData.API_ID;

    let checkAPIIDExists = null;

    checkAPIIDExists = data.find((apiConfig) => apiConfig.API_ID === API_ID);

    if (checkAPIIDExists) {
      NotificationManager.error("", "API ID exists!", 10000);
    } else {
      const payload = [
        {
          API_ID: formData.API_ID,
          MOD: formData.MOD,
          PATH: formData.PATH,
          OPERATION: formData.OPERATION,
          STATE: formData.STATE,
          NAME: formData.NAME,
          REF_TYPE: formData.REF_TYPE,
          REF_ID: formData.REF_ID,
          SECURITY_POLICY: formData.SECURITY_POLICY,
          SAMPLE_DATA: formData.SAMPLE_DATA,
          REF_DATA: formData.REF_DATA,
        },
      ];

      const resourcePath = "integrations/cfg/apiconfigs";

      API.AddRecord(resourcePath, payload).then((response) => {
        if (response.code === 200) {
          NotificationManager.success(
            "Record added!",
            "API Config Entry",
            10000
          );
          fetchAPIConfigsFromAllEnv();
        } else {
          NotificationManager.error(response.message, "Failed!", 10000);
        }
      });
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <Box>
      <Stack spacing={0}>
        <FormField required id="API_ID" name="API_ID" label="ID" disabled={!editable} value={formData.API_ID} onChange={handleChange} />
        <FormField required id="MOD" name="MOD" label="MOD" disabled={!editable} value={formData.MOD} onChange={handleChange} />
        <FormField required id="PATH" name="PATH" label="PATH" disabled={!editable} value={formData.PATH} onChange={handleChange} />
        <FormSelectField id="OPERATION" name="OPERATION" label="Operation" disabled={!editable} value={formData.OPERATION} onChange={handleChange} items={operations} />
        <FormSelectField id="STATE" name="STATE" label="State" disabled={!editable} value={formData.STATE} onChange={handleChange} items={states} />
        <FormField required id="NAME" name="NAME" label="Name" disabled={!editable} value={formData.NAME} onChange={handleChange} />
        <FormSelectField id="REF_TYPE" name="REF_TYPE" label="Ref Type" disabled={!editable} value={formData.REF_TYPE} onChange={handleChange} items={refTypes} />
        <FormField required id="REF_ID" name="REF_ID" label="Ref ID" disabled={!editable} value={formData.REF_ID} onChange={handleChange} />
        <FormField required id="REF_DATA" name="REF_DATA" label="Ref Data" disabled={!editable} value={formData.REF_DATA} onChange={handleChange} />
        <FormField required id="SECURITY_POLICY" name="SECURITY_POLICY" label="Security Policy" disabled={!editable} value={formData.SECURITY_POLICY} onChange={handleChange} />
        <FormField required id="SAMPLE_DATA" name="SAMPLE_DATA" label="Sample Data" disabled={!editable} value={formData.SAMPLE_DATA} onChange={handleChange} />
      </Stack>

      <FormActions>
        <Button variant="outlined" disabled={editable} onClick={onEditClick}>
          Edit
        </Button>
        <Button variant="contained" color="primary" disabled={!editable} onClick={handleSubmit}>
          Save
        </Button>
        <Button variant="outlined" color="secondary" disabled={!editable} onClick={handleClone}>
          Clone
        </Button>
        <Button variant="text" color="inherit" onClick={handleDetailClose}>
          Close
        </Button>
      </FormActions>
    </Box>
  );
};

export default ViewEditAPIConfig;
